import { render, staticRenderFns } from "./MreglaForm.vue?vue&type=template&id=10ac3c58"
import script from "./MreglaForm.vue?vue&type=script&lang=js"
export * from "./MreglaForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports